module.exports = __webpack_public_path__ + "img/bike-ride-3-min.28659aad.png";